// import { routeNames } from 'src/routes'

export const cards = [
  {
    title: 'Create Token',
    installs: '',
    icon: 'dollar',
    icons: ['bnb', 'ethereum', 'multiversx', 'polygon'],
    route: '/issue-token',
    dataCy: 'create-token',
    live: true,
  },
  {
    title: 'Create NFT Collection',
    installs: '',
    icon: 'puzzle',
    icons: ['bnb', 'ethereum', 'multiversx', 'polygon'],
    route: '/issue-nft-collection',
    dataCy: 'create-nft',
    live: true,
  },
  {
    title: 'Create Staking Contract',
    installs: '',
    icon: 'puzzle',
    icons: ['bnb', 'ethereum', 'polygon'],
    route: '/issue-staking-contract',
    live: true,
  },
  {
    title: 'Create Vesting Contract',
    installs: '',
    icon: 'puzzle',
    icons: ['bnb', 'ethereum', 'polygon'],
    route: '/issue-vesting-contract',
    live: true,
  },
  {
    title: 'Manage Token',
    installs: 'In progress',
    icon: 'edit-file',
    icons: [],
    route: '',
    live: false,
  },
  {
    title: 'Manage NFT Collection',
    installs: 'In progress',
    icon: 'edit-file',
    icons: [],
    route: '',
    live: false,
  },
  {
    title: 'Create Cross-Chain Token',
    installs: 'In progress',
    icon: 'edit-file',
    icons: [],
    route: '',
    live: false,
  },
  {
    title: 'Create Bridge',
    installs: 'In progress',
    icon: 'edit-file',
    icons: [],
    route: '',
    live: false,
  },
  {
    title: 'Create Watcher',
    installs: 'In progress',
    icon: 'edit-file',
    icons: [],
    route: '',
    live: false,
  },
]
